import { render, staticRenderFns } from "./ProjectPresent.vue?vue&type=template&id=ee5a70aa&scoped=true"
import script from "./ProjectPresent.vue?vue&type=script&lang=js"
export * from "./ProjectPresent.vue?vue&type=script&lang=js"
import style0 from "./ProjectPresent.vue?vue&type=style&index=0&id=ee5a70aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee5a70aa",
  null
  
)

export default component.exports